import type { DxTradePosition } from '@model/DxTrade.types'

type SideAndDateRangeFilters<TSide extends string = string> = {
  side?: TSide
  from?: string
  to?: string
}

export const filterBySideAndDateRange = <TItem, TSide extends string = string>(
  items: TItem[],
  filters: SideAndDateRangeFilters<TSide> | undefined,
  getSide: (item: TItem) => TSide | null | undefined,
  getDate: (item: TItem) => string | null | undefined
): TItem[] => {
  if (!filters) return items

  const from = filters.from ? Date.parse(filters.from) : null
  const to = filters.to ? Date.parse(filters.to) : null

  return items.filter((item) => {
    const matchSide = !filters.side || getSide(item) === filters.side
    if (!matchSide) return false

    if (from !== null || to !== null) {
      const date = getDate(item)
      if (!date) return false

      const time = Date.parse(date)
      if (Number.isNaN(time)) return false

      const matchFrom = from === null || time >= from
      const matchTo = to === null || time <= to
      return matchFrom && matchTo
    }

    return true
  })
}
export type OpenPositionsFilters = {
  side?: DxTradePosition['side']
  openTimeFrom?: string
  openTimeTo?: string
}

export const filterOpenPositions = (
  positions: DxTradePosition[],
  filters?: OpenPositionsFilters
): DxTradePosition[] => {
  return filterBySideAndDateRange(
    positions,
    filters
      ? {
          side: filters.side ?? undefined,
          from: filters.openTimeFrom,
          to: filters.openTimeTo,
        }
      : undefined,
    (position) => position.side,
    (position) => position.openTime
  )
}
